import { render, staticRenderFns } from "./adminBarrierList.vue?vue&type=template&id=0ed927ea&scoped=true"
import script from "./adminBarrierList.vue?vue&type=script&lang=js"
export * from "./adminBarrierList.vue?vue&type=script&lang=js"
import style0 from "./adminBarrierList.vue?vue&type=style&index=0&id=0ed927ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed927ea",
  null
  
)

export default component.exports